export enum UserCompanyTypes {
	partner = 'partner',
	client = 'client',
}
